import { render, staticRenderFns } from "./OrdersMap.vue?vue&type=template&id=436b2755&"
import script from "./OrdersMap.vue?vue&type=script&lang=js&"
export * from "./OrdersMap.vue?vue&type=script&lang=js&"
import style0 from "./OrdersMap.vue?vue&type=style&index=0&id=436b2755&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports